// extracted by mini-css-extract-plugin
module.exports = {"LogoComp":"Logo_LogoComp__PumwN","LogoName":"Logo_LogoName__2vtMj"};